import { render } from "./AuthTemplate.vue?vue&type=template&id=c7cfc3ba&scoped=true"
import script from "./AuthTemplate.vue?vue&type=script&lang=js"
export * from "./AuthTemplate.vue?vue&type=script&lang=js"

import "./AuthTemplate.vue?vue&type=style&index=0&id=c7cfc3ba&scoped=true&lang=css"
import "./AuthTemplate.vue?vue&type=style&index=1&id=c7cfc3ba&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7cfc3ba"]])

export default __exports__